import { fmtRemaining, remainingMs } from '../../core/clock';

interface Entry {
  el: HTMLElement;
  until: string;
  onZero?: () => void;
  fired: boolean;
}

/** 「あと m:ss」の表示を1秒ごとに更新する。0になったら onZero を1回だけ呼ぶ */
export class Ticker {
  private entries = new Set<Entry>();
  private timer: ReturnType<typeof setInterval> | null = null;

  /** el の文字を期限までの残り m:ss にする。すでに過ぎていれば何もせず onZero も呼ばない */
  add(el: HTMLElement, untilIso: string, onZero?: () => void): void {
    const e: Entry = { el, until: untilIso, onZero, fired: false };
    el.textContent = fmtRemaining(remainingMs(untilIso));
    this.entries.add(e);
  }

  tick(): void {
    for (const e of [...this.entries]) {
      if (!e.el.isConnected) {
        this.entries.delete(e);
        continue;
      }
      const ms = remainingMs(e.until);
      e.el.textContent = fmtRemaining(ms);
      if (ms <= 0 && !e.fired) {
        e.fired = true;
        this.entries.delete(e);
        e.onZero?.();
      }
    }
  }

  start(): void {
    if (this.timer) return;
    this.timer = setInterval(() => this.tick(), 1000);
  }

  stop(): void {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  clear(): void {
    this.entries.clear();
  }
}
